import gql from 'graphql-tag';

export const GlobalThemePreferenceQuery = gql`
	query GlobalThemePreferenceQuery($accountId: ID!) {
		settings_userPreferencesGlobal(accountId: $accountId) {
			theme
		}
	}
`;
